module.exports = __webpack_public_path__ + "static/media/CMP.45a80a10.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/CMP.jpg
// module id = 1719
// module chunks = 1